import {SiteSlug} from "@pg-mono/km-routes";

export const getFullKMLink = (kmHost: string, getPath: (params: {site: SiteSlug}) => string) => `${kmHost}${getPath({site: SiteSlug.RP})}`;
